"use client";

import { useFilterablePaginatedScroll } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/useFilterablePaginatedScroll";
import React, { useState, PropsWithChildren, createContext } from "react";

interface FilterablePaginatedSectionState {
  scrollRef?: React.MutableRefObject<HTMLDivElement | null>;
  scrollToTopFunc?: (params: { toTop?: boolean }) => void;
  isScrollingToTop?: boolean;
  setIsScrollingToTop?: React.Dispatch<React.SetStateAction<boolean>>;
  isTransitioning?: boolean;
  setIsTransitioning?: React.Dispatch<React.SetStateAction<boolean>>;
  isTransitioningFunction?: ((isTransitioning: boolean) => void) | undefined;
  setIsTransitioningFunction?: React.Dispatch<
    React.SetStateAction<((isTransitioning: boolean) => void) | undefined>
  >;
}

export const FilterablePaginatedSectionContext =
  createContext<FilterablePaginatedSectionState>({});

export const FilterablePaginatedSectionContextProvider: React.FC<
  PropsWithChildren
> = ({ children }) => {
  const { scrollRef, scrollToTop } = useFilterablePaginatedScroll();
  const [isScrollingToTop, setIsScrollingToTop] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isTransitioningFunction, setIsTransitioningFunction] = useState<
    ((isTransitioning: boolean) => void) | undefined
  >(undefined);

  return (
    <FilterablePaginatedSectionContext.Provider
      value={{
        scrollRef,
        scrollToTopFunc: scrollToTop,
        isScrollingToTop,
        setIsScrollingToTop,
        isTransitioning,
        setIsTransitioning,
        isTransitioningFunction,
        setIsTransitioningFunction,
      }}
    >
      {children}
    </FilterablePaginatedSectionContext.Provider>
  );
};
